module.exports = __webpack_public_path__ + "img/shoufangshenqing_1.37579a43.png";